import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UploadfilePopupComponent } from './uploadfile-popup.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CustomDropdownModule } from 'src/app/shared/components/custom-dropdown/custom-dropdown.module';
import { CustomInputModule } from 'src/app/shared/components/custom-input/custom-input.module';
import { MaterialModule } from 'src/app/shared/material/material.module';



@NgModule({
  declarations: [
    UploadfilePopupComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    CustomDropdownModule,
    FormsModule,
    ReactiveFormsModule,
    CustomInputModule
  ]
})
export class UploadfilePopupModule { }
